import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-emergency-service',
  templateUrl: './emergency-service.component.html',
  styleUrls: ['./emergency-service.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class EmergencyServiceComponent {
  isContentVisible = false;

  toggleContent() {
    this.isContentVisible = !this.isContentVisible;
  }
}